module.exports = __webpack_public_path__ + "static/img/banner_02.ec54fdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/lgis/banner_02.jpg
// module id = 6dlL
// module chunks = 23